import { Fragment, useEffect } from 'react'
import DynamicForm from 'components/DynamicForm'
import { setEvaluationRule } from 'redux/formDisplay'
import { useDispatch } from 'react-redux'

const Question = (props) => {
    const {
        setSelectedData,
        selectedData,
        inputFields,
        formErr,
        clearFieldError,
        questionnaireId,
        isUserInitiated,
        evaluationRules
    } = props
    const dispatch = useDispatch()
    useEffect(() => {
        if(evaluationRules) {
            dispatch(setEvaluationRule(evaluationRules))
        }
    },[])
    return (
        <>
            {
                inputFields && inputFields?.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <DynamicForm
                                landing={true}
                                recursive={true}
                                formFields={item}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                formErr={formErr}
                                clearFieldError={clearFieldError}
                                questionnaireId={questionnaireId}
                                isUserInitiated={isUserInitiated}
                            />
                        </Fragment>
                    )
                })
             }
        </>
    )
}

export default Question;